import * as React from 'react';
import * as moment from 'moment';
import * as _ from 'lodash';
import * as qs from 'query-string';
import { Dispatch, connect } from 'react-redux';
import { Row, Col, FormGroup, ControlLabel, FormControl, Button, HelpBlock, Label, Panel, Alert } from 'react-bootstrap';
import { IListItem, IWatrRequest } from '@nkr/models/index';
import { AppActionCreators, IAppState, IApplicationState, IWatrRequestUpdateResponse, IDonorShieldDirectResponse, WatrActionCreators, IWatrDuplicateCountResponse, IWatrRequestLookupDataResponse } from '@nkr/store/index';
import { IWatrUpdateDonorRequest } from '@nkr/store/watr/actions';
import { Country, OrganType } from '@nkr/enums/index';
import { toast } from 'react-toastify';
import { AxiosError } from 'axios';
import { IValidation } from './validation'
import { Utility } from '@nkr/services/utility';
import MaskedInput from 'react-maskedinput';

interface IProps {
    centerId: number,
    isSuperUser: boolean
}

interface IState {
    id: number,
    data: IWatrRequest,
    validationSave: IValidation,
    donorId: number,
    donorShieldId: number,
    stateList: IListItem[],
    countryList: IListItem[],
    dirty: boolean
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message: string) => Promise<void>,
    hideLoading: () => void,
    getDonorShieldDirectRecord: (donorShieldId: number, centerId: number) => Promise<IDonorShieldDirectResponse>,
    getDonorRecord: (donorId: number, centerId: number) => Promise<IDonorShieldDirectResponse>,
    getWatrRequestRecord: (watrId: number, centerId: number) => Promise<IWatrRequestUpdateResponse>,
    createDonorRequest: (donorId: number, donorShieldId: number, firstName: string, middleInitial: string, lastName: string, email: string, mobile: string, birthDate: string, donationDate: string, addressLine1: string, addressLine2: string, city: string, state: number, postalCode: string, country: number, countryOfCitizenship: number, centerId: number, isSuperUser: boolean) => Promise<IWatrRequestUpdateResponse>,
    updateDonorRequest: (request: IWatrUpdateDonorRequest) => Promise<IWatrRequestUpdateResponse>,
    getDuplicateCounts: (watrId: number, email: string, mobile: string, donationOrganType: number) => Promise<IWatrDuplicateCountResponse>
    getLookupData: () => Promise<IWatrRequestLookupDataResponse>
}

type TProps = IProps & IStateProps & IDispatchProps;

class AddRequestForm extends React.Component<TProps, IState> {
    formatPhoneNumber = (phoneNumber: string): string => {
        if (!phoneNumber) return '';
        const digits = phoneNumber.replace(/\D/g, '');
        if (digits.length === 10) {
            return `(${digits.substring(0, 3)}) ${digits.substring(3, 6)}-${digits.substring(6)}`;
        }
        return phoneNumber;
    }

    stripPhoneNumber = (phoneNumber: string): string => {
        if (!phoneNumber) return '';
        return phoneNumber.replace(/\D/g, '');
    }

    readonly state: IState = {
        id: 0,
        data: null,
        validationSave: {
            firstName: true,
            middleInitial: true,
            lastName: true,
            email: true,
            mobile: true,
            birthdate: true,
            watrEmailDuplicate: true,
            watrMobileDuplicate: true,
            invalidDonationDate: true,
            addressLine1: true,
            addressLine2: true,
            city: true,
            state: true,
            postalCode: true,
            country: true,
            countryOfCitizenship: true
        },
        donorId: 0,
        donorShieldId: 0,
        stateList: [],
        countryList: [],
        dirty: false
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        let q = qs.parse(location.search);
        let watrId = q.id != null ? q.id : 0;
        let donorId = q.donorId != null ? parseInt(q.donorId) : 0;
        let donorShieldId = q.donorShieldId != null ? parseInt(q.donorShieldId) : 0;

        this.props.showLoading('Retrieving Watr Request, one moment please...').then(async () => {
            let lookupDataResponse = await this.props.getLookupData();
            let stateList: IListItem[] = [];
            let countryList: IListItem[] = [];

            if (lookupDataResponse.data.success) {
                stateList = lookupDataResponse.data.results.stateList;
                countryList = lookupDataResponse.data.results.countryList
            }

            if (watrId == 0 && donorShieldId != 0) {
                let donorShieldResponse = await this.props.getDonorShieldDirectRecord(donorShieldId, this.props.centerId);

                if (donorShieldResponse.data.success) {
                    if (donorShieldResponse.data.results != null) {
                        let {
                            donorName,
                            donorEmail,
                            donorPhoneNumber,
                            donorBirthdate,
                            surgeryDate,
                            country,
                            countryOfCitizenship,
                            organType,
                            donorAddressLine1: addressLine1,
                            donorAddressLine2: addressLine2,
                            donorCity: city,
                            donorState: state,
                            donorPostalCode: postalCode,
                        } = donorShieldResponse.data.results;

                        let nameArray = donorName.length > 0 ? donorName.split(' ') : [];
                        let firstName = nameArray[0];
                        let lastName = nameArray.slice(1).join(' ');

                        this.setState({
                            id: donorShieldId,
                            data: {
                                ...this.state.data,
                                centerId: this.props.centerId,
                                firstName,
                                middleInitial: '',
                                lastName,
                                email: donorEmail,
                                mobile: this.formatPhoneNumber(donorPhoneNumber),
                                birthDate: donorBirthdate,
                                donationDate: new Date(moment(surgeryDate).format('MM/DD/YYYY')),
                                addressLine1,
                                addressLine2,
                                city,
                                state,
                                postalCode,
                                country,
                                countryOfCitizenship,
                                donationOrganType: organType != null ? organType : OrganType.Kidney
                            },
                            stateList,
                            countryList
                        });
                    } else {
                        this.setState({
                            id: donorShieldId,
                            data: null,
                            stateList,
                            countryList
                        });
                    }
                }
            } else if (watrId == 0 && donorId != 0) {
                let donorResponse = await this.props.getDonorRecord(donorId, this.props.centerId);

                if (donorResponse.data.success) {
                    if (donorResponse.data.results != null) {

                        let {
                            donorName,
                            donorEmail,
                            donorPhoneNumber,
                            donorBirthdate,
                            surgeryDate,
                            country,
                            countryOfCitizenship,
                            organType,
                            donorAddressLine1: addressLine1,
                            donorAddressLine2: addressLine2,
                            donorCity: city,
                            donorState: state,
                            donorPostalCode: postalCode,
                        } = donorResponse.data.results;

                        let nameArray = donorName.length > 0 ? donorName.split(' ') : [];
                        let firstName = nameArray[0];
                        let lastName = nameArray.slice(1).join(' ');

                        this.setState({
                            id: donorShieldId,
                            data: {
                                ...this.state.data,
                                centerId: this.props.centerId,
                                firstName,
                                middleInitial: '',
                                lastName,
                                email: donorEmail,
                                mobile: this.formatPhoneNumber(donorPhoneNumber),
                                birthDate: donorBirthdate,
                                donationDate: new Date(moment(surgeryDate).format('MM/DD/YYYY')),
                                addressLine1,
                                addressLine2,
                                city,
                                state,
                                postalCode,
                                country,
                                countryOfCitizenship,
                                donationOrganType: organType != null ? organType : OrganType.Kidney
                            },
                            stateList,
                            countryList
                        });
                    } else {
                        this.setState({
                            id: donorShieldId,
                            data: null,
                            stateList,
                            countryList
                        });
                    }
                }
            } else {
                let watrRequestResponse = await this.props.getWatrRequestRecord(watrId, this.props.centerId);

                if (watrRequestResponse.data.success) {
                    if (watrRequestResponse.data.results != null) {

                        let {
                            id,
                            firstName,
                            lastName,
                            email,
                            mobile,
                            birthDate,
                            donationDate,
                            country,
                            countryOfCitizenship,
                            donationOrganType,
                            addressLine1,
                            addressLine2,
                            city,
                            state,
                            postalCode
                        } = watrRequestResponse.data.results;

                        this.setState({
                            id: donorShieldId,
                            data: {
                                ...this.state.data,
                                id,
                                centerId: this.props.centerId,
                                firstName,
                                middleInitial: '',
                                lastName,
                                email,
                                mobile: this.formatPhoneNumber(mobile),
                                birthDate,
                                donationDate: new Date(moment(donationDate).format('MM/DD/YYYY')),
                                addressLine1,
                                addressLine2,
                                city,
                                state,
                                postalCode,
                                country,
                                countryOfCitizenship,
                                donationOrganType: donationOrganType != null ? donationOrganType : OrganType.Kidney
                            },
                            stateList,
                            countryList
                        });
                    } else {
                        this.setState({
                            id: donorShieldId,
                            data: null,
                            stateList,
                            countryList
                        });
                    }
                }
            }
        });

        this.props.hideLoading();
    }

    formatBirthdateForDisplay = (birthDate: string) => {
        if (!birthDate) return '';

        if (birthDate.includes('/') && birthDate.length === 10) {
            return birthDate;
        }

        let birthMoment = moment(birthDate);
        if (!birthMoment.isValid()) {
            birthMoment = moment(birthDate, 'MM/DD/YYYY');
        }

        return birthMoment.isValid() ? birthMoment.format('MM/DD/YYYY') : birthDate;
    }

    convertBirthdateToISO = (birthDate: string) => {
        if (!birthDate) return '';

        let birthMoment = moment(birthDate);

        if (!birthMoment.isValid()) {
            birthMoment = moment(birthDate, 'MM/DD/YYYY');
        }

        return birthMoment.isValid() ? birthMoment.format('YYYY-MM-DD') : birthDate;
    }

    handleDataChange = async (e: React.FormEvent<FormControl & HTMLInputElement & HTMLSelectElement>) => {
        let { id, value } = e.currentTarget;
        let data = _.cloneDeep(this.state.data);

        if (id === 'state' || id === 'country' || id === 'countryOfCitizenship') {
            data[id] = value ? parseInt(value) : null;
        } else if (id === 'middleInitial') {
            data[id] = value ? value.toUpperCase().substring(0, 1) : '';
        } else if (id === 'birthdate') {
            data['birthDate'] = value;
        } else if (typeof value === 'number') {
            data[id] = parseInt(value);
        } else {
            data[id] = value;
        }

        if (id == 'country') {
            if (parseInt(value) != Country.UnitedStates) {
                data.state = null;
                data.province = '';
            }
        }

        this.setState({
            data
        });
    }

    validateSave = async () => {
        let watrEmailCount = 0;
        let watrMobileCount = 0;
        let q = qs.parse(location.search);
        let watrId = q.id != null ? q.id : 0;

        let {
            id,
            donorId,
            firstName,
            middleInitial,
            lastName,
            email,
            mobile,
            birthDate,
            donationDate,
            addressLine1,
            addressLine2,
            city,
            state,
            postalCode,
            country,
            countryOfCitizenship,
            donationOrganType
        } = this.state.data;


        if ((email != '' || mobile != '') && watrId == 0) {
            let strippedMobile = this.stripPhoneNumber(mobile);
            const rawQueryId = q.id;
            const excludeWatrId = parseInt(String(Array.isArray(rawQueryId) ? rawQueryId[0] : rawQueryId || 0), 10) || 0;
            const organTypeForDupes = donationOrganType != null ? donationOrganType : OrganType.Kidney;
            let duplicateReponse = await this.props.getDuplicateCounts(excludeWatrId, email, strippedMobile, organTypeForDupes);

            const dupResults = duplicateReponse.data.results;
            if (duplicateReponse.data.success && dupResults && typeof dupResults === 'object' && 'watrEmailCount' in dupResults) {
                watrEmailCount = dupResults.watrEmailCount;
                watrMobileCount = dupResults.watrMobileCount;
            }
        }

        let hasAnyAddressField = addressLine1 != '' || city != '' || state != null || postalCode != '' || country >= 0;
        let hasAllRequiredAddressFields = addressLine1 != '' && city != '' && state != null && postalCode != '' && country >= 0;
        let isAddressValid = !hasAnyAddressField || hasAllRequiredAddressFields;

        let isUSCountry = country === Country.UnitedStates;
        let isStateValid = !isUSCountry || (state !== null && state !== undefined);
        let isPostalCodeValid = postalCode !== '' && (isUSCountry ? /^\d{5}(-\d{4})?$/.test(postalCode) : postalCode.length >= 3);

        let isBirthdateValid = false;

        if (birthDate) {
            let birthMoment = moment(birthDate);

            if (!birthMoment.isValid()) {
                birthMoment = moment(birthDate, 'MM/DD/YYYY');
            }

            isBirthdateValid = birthMoment.isValid() && birthMoment.isBefore(moment(), 'day');
        }

        let strippedMobile = this.stripPhoneNumber(mobile);
        let validPhoneNumber = strippedMobile.length === 10;

        let validation: IValidation = {
            firstName: firstName !== '',
            middleInitial: true,
            lastName: lastName !== '',
            mobile: validPhoneNumber,
            email: Utility.isValidEmail(email),
            birthdate: isBirthdateValid,
            watrEmailDuplicate: watrEmailCount === 0,
            watrMobileDuplicate: watrMobileCount === 0,
            invalidDonationDate: true,
            addressLine1: addressLine1 !== '',
            addressLine2: true,
            city: city !== '',
            state: isStateValid,
            postalCode: isPostalCodeValid,
            country: country !== null && country !== undefined,
            countryOfCitizenship: true
        };

        return validation;
    }

    isValid = () => {
        let { validationSave } = this.state;
        let isValid = false;

        isValid =
            validationSave.firstName &&
            validationSave.middleInitial &&
            validationSave.lastName &&
            validationSave.email &&
            validationSave.mobile &&
            validationSave.birthdate &&
            validationSave.watrEmailDuplicate &&
            validationSave.watrMobileDuplicate &&
            validationSave.invalidDonationDate &&
            validationSave.addressLine1 &&
            validationSave.addressLine2 &&
            validationSave.city &&
            validationSave.state &&
            validationSave.postalCode &&
            validationSave.country &&
            validationSave.countryOfCitizenship

        return isValid;
    }

    handleCreateDonorRequest = async () => {
        let q = qs.parse(location.search);
        let watrId = q.id != null ? q.id : 0;
        let donorId = q.donorId != null ? parseInt(q.donorId) : 0;
        let donorShieldId = q.donorShieldId != null ? parseInt(q.donorShieldId) : 0;

        let {
            id,
            firstName,
            middleInitial,
            lastName,
            email,
            mobile,
            birthDate,
            donationDate,
            expirationDate,
            addressLine1,
            addressLine2,
            city,
            state,
            postalCode,
            country,
            countryOfCitizenship
        } = this.state.data;

        let validationSave = await this.validateSave();

        this.setState({
            validationSave,
            dirty: true
        }, () => {
            if (this.isValid()) {
                if (watrId == 0) {
                    let message = 'Saving New Request, one moment please...';

                    this.props.showLoading(message).then(() => {
                        let strippedMobile = this.stripPhoneNumber(mobile);
                        this.props.createDonorRequest(donorId, donorShieldId, firstName, middleInitial || '', lastName, email, strippedMobile, this.convertBirthdateToISO(birthDate), moment(donationDate).format('YYYY-MM-DD'), addressLine1 || '', addressLine2 || '', city || '', state, postalCode || '', country, countryOfCitizenship, this.props.centerId, this.props.isSuperUser)
                            .then(response => {
                                if (response.data.success) {
                                    let req = response.data.results;
                                    let viewData = _.cloneDeep(req);

                                    this.setState({
                                        data: {
                                            ...this.state.data,
                                            centerId: this.props.centerId,
                                            firstName: viewData.firstName,
                                            lastName: viewData.lastName,
                                            email: viewData.email,
                                            mobile: this.formatPhoneNumber(viewData.mobilePhone),
                                            birthDate: viewData.birthdate
                                        }
                                    }, () => {
                                        this.props.hideLoading();

                                        toast.success('Wage Request Saved Successfully.  An invitation email has been sent to the donor.  Redirecting to the DSCP Report...', { autoClose: false });

                                        setTimeout(() => {
                                            window.location.href = '/center/' + this.props.centerId + '/donors/watr/pend-doc';
                                        }, 5000);
                                    });
                                } else {
                                    toast.error(response.data.results, { autoClose: false });
                                }
                            })
                            .finally(() => {
                                this.props.hideLoading();
                            });
                    });
                }
                else {
                    let message = 'Saving Request, one moment please...';

                    let strippedMobile = this.stripPhoneNumber(mobile);
                    let request: IWatrUpdateDonorRequest = {
                        requestId: watrId,
                        firstName,
                        middleInitial: middleInitial || '',
                        lastName,
                        email,
                        mobile: strippedMobile,
                        birthDate: this.convertBirthdateToISO(birthDate),
                        expirationDate: '',
                        achAccountNumber: '',
                        achRoutingNumber: '',
                        intlBankingNumber: '',
                        intlSwiftNumber: '',
                        addressLine1: addressLine1 || '',
                        addressLine2: addressLine2 || '',
                        city: city || '',
                        state: state || 0,
                        postalCode: postalCode || '',
                        country: country || 0,
                        countryOfCitizenship: countryOfCitizenship || 0,
                        isAdmin: this.props.isSuperUser,
                        donationDate: moment(donationDate).format('YYYY-MM-DD'),
                        bankInformation: {
                            nameOfBank: '',
                            cityTownLocality: '',
                            stateProvinceRegion: '',
                            postalCode: '',
                            additionalCode: ''
                        }
                    };

                    this.props.showLoading(message).then(() => {
                        this.props.updateDonorRequest(request)
                            .then(response => {
                                if (response.data.success) {
                                    let req = response.data.results;
                                    let viewData = _.cloneDeep(req);

                                    this.setState({
                                        data: {
                                            ...this.state.data,
                                            centerId: this.props.centerId,
                                            firstName: viewData.firstName,
                                            lastName: viewData.lastName,
                                            email: viewData.email,
                                            mobile: this.formatPhoneNumber(viewData.mobilePhone),
                                            birthDate: viewData.birthdate,
                                            donationDate: viewData.donationDate,
                                            expirationDate: viewData.expirationDate
                                        }
                                    }, () => {
                                        this.props.hideLoading();
                                        toast.success('Wage Request Saved Successfully', { autoClose: false });
                                    });
                                }
                            })
                            .catch((error: AxiosError) => {
                                this.props.hideLoading();
                            });
                    });
                }
            } else {
                toast.error('Not all fields have been populated.  Please review form before submission.');
            }
        });
    }

    render = () => {
        if (this.state.data == null)
            return (<>Missing Donor Shield Entry ID or Donor ID</>);

        const hasAnyAddressField = this.state.data.addressLine1 || this.state.data.city || this.state.data.state || this.state.data.postalCode || this.state.data.country;
        const hasAllRequiredAddressFields = this.state.data.addressLine1 && this.state.data.city && this.state.data.state && this.state.data.postalCode && this.state.data.country;
        const invalidAddress = hasAnyAddressField && !hasAllRequiredAddressFields;

        return (
            <>
                <style>
                    {`
                        .form-section h5 {
                            font-size: 18px;
                            margin-bottom: 20px;
                            padding-bottom: 8px;
                            border-bottom: 2px solid #3498db;
                        }
                        
                        .form-group {
                            margin-bottom: 20px;
                        }
                        
                        .form-group .control-label {
                            font-weight: 600;
                            color: #2c3e50;
                            padding-top: 7px;
                        }
                        
                        .form-control:focus {
                            border-color: #3498db;
                            box-shadow: 0 0 0 0.2rem rgba(52, 152, 219, 0.25);
                        }
                        
                        .form-control[disabled] {
                            background-color: #f8f9fa;
                            opacity: 0.6;
                        }
                        
                        .help-block {
                            font-size: 12px;
                            margin-top: 5px;
                        }
                        
                        .badge {
                            font-size: 10px;
                            padding: 2px 6px;
                        }
                        
                        @media (max-width: 768px) {
                            .form-group .control-label {
                                margin-bottom: 5px;
                            }
                            
                            .form-section h5 {
                                font-size: 16px;
                                margin-bottom: 15px;
                            }
                        }
                    `}
                </style>

                <Row>
                    <Col xs={12} md={10} mdOffset={1}>
                        <h4 style={{ margin: '20px 0px', color: '#333' }}>
                            <i className='fa fa-file-text-o' style={{ marginRight: '10px' }}></i>
                            Request Donor Shield Reimbursement
                        </h4>

                        <Alert bsStyle='info' bsSize='sm'>
                            <i className='fa fa-info-circle' style={{ marginRight: '8px' }}></i>
                            This form may be used to apply a donor for lost wage and/or expense reimbursement
                        </Alert>

                        <Panel>
                            <Panel.Heading>Personal Information</Panel.Heading>
                            <Panel.Body>
                                <FormGroup style={{ marginBottom: '20px' }} validationState={this.state.dirty && !this.state.validationSave.firstName ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='firstName' style={{ fontWeight: 600, color: '#2c3e50' }}>
                                        First Name:
                                        <span className='text-danger' style={{ marginLeft: '3px' }}>*</span>
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='firstName'
                                            id='firstName'
                                            type='text'
                                            value={this.state.data.firstName}
                                            onChange={this.handleDataChange}
                                            placeholder='Enter first name'
                                        />
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.middleInitial ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='middleInitial'>
                                        Middle Initial:
                                        <span className='text-muted' style={{ fontSize: '12px', marginLeft: '5px' }}>
                                            <span className='badge' style={{ backgroundColor: '#6c757d' }}>optional</span>
                                        </span>
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='middleInitial'
                                            id='middleInitial'
                                            type='text'
                                            maxLength={1}
                                            value={this.state.data.middleInitial || ''}
                                            onChange={this.handleDataChange}
                                        />
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.lastName ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='lastName'>
                                        Last Name:
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='lastName'
                                            id='lastName'
                                            type='text'
                                            value={this.state.data.lastName}
                                            onChange={this.handleDataChange}
                                        />
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.email ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='email'>
                                        E-mail:
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='email'
                                            id='email'
                                            type='text'
                                            value={this.state.data.email}
                                            onChange={this.handleDataChange}
                                        />
                                        {!this.state.validationSave.watrEmailDuplicate && (
                                            <HelpBlock><Label bsStyle='danger' bsSize='large'>Duplicate Entry</Label></HelpBlock>
                                        )}
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.mobile ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='mobilePhone'>
                                        Mobile Phone:
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <MaskedInput
                                            className='form-control'
                                            id='mobile'
                                            name='mobile'
                                            mask='(111) 111-1111'
                                            placeholder='(XXX) XXX-XXXX'
                                            style={{ borderColor: this.state.validationSave.mobile ? '#ccc' : '#a94442' }}
                                            value={this.state.data.mobile}
                                            onChange={this.handleDataChange}
                                        />
                                        {!this.state.validationSave.watrMobileDuplicate && (
                                            <HelpBlock><Label bsStyle='danger' bsSize='large'>Duplicate Entry</Label></HelpBlock>
                                        )}
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.birthdate ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='birthdate'>
                                        Birthdate:
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <MaskedInput
                                            className='form-control input-sm'
                                            mask='11/11/1111'
                                            id='birthdate'
                                            name='birthdate'
                                            value={this.state.data.birthDate ? this.formatBirthdateForDisplay(this.state.data.birthDate) : ''}
                                            onChange={this.handleDataChange}
                                        />
                                        {this.state.dirty && !this.state.validationSave.birthdate && (
                                            <HelpBlock>Please enter a valid birthdate (MM/DD/YYYY)</HelpBlock>
                                        )}
                                    </Col>
                                </FormGroup>
                            </Panel.Body>
                        </Panel>

                        <Panel>
                            <Panel.Heading>Country Information</Panel.Heading>
                            <Panel.Body>
                                <FormGroup style={{ marginBottom: '20px' }} validationState={this.state.dirty && !this.state.validationSave.country ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='country' style={{ fontWeight: 600, color: '#2c3e50' }}>
                                        Country of Residence:
                                        <span className='text-danger' style={{ marginLeft: '3px' }}>*</span>
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <div style={{ position: 'relative' }}>
                                            <FormControl
                                                componentClass='select'
                                                name='country'
                                                id='country'
                                                value={this.state.data.country}
                                                onChange={this.handleDataChange}
                                                style={{ paddingRight: '30px' }}
                                            >
                                                <option value=''>- Please Select -</option>
                                                {this.state.countryList.map(item =>
                                                    <option key={'ctry-' + item.id} value={item.id}>
                                                        {item.description}
                                                    </option>
                                                )}
                                            </FormControl>
                                            <i className='fa fa-globe' style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#7f8c8d',
                                                pointerEvents: 'none'
                                            }}></i>
                                        </div>
                                        {this.state.dirty && !this.state.validationSave.country && (
                                            <HelpBlock>Country of residence is required</HelpBlock>
                                        )}
                                    </Col>
                                </FormGroup>

                                <FormGroup style={{ marginBottom: '20px' }} validationState={this.state.dirty && !this.state.validationSave.countryOfCitizenship ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='countryOfCitizenship' style={{ fontWeight: 600, color: '#2c3e50' }}>
                                        Country of Citizenship:
                                        <span className='text-muted' style={{ fontSize: '12px', marginLeft: '5px' }}>
                                            <span className='badge' style={{ backgroundColor: '#6c757d' }}>optional</span>
                                        </span>
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <div style={{ position: 'relative' }}>
                                            <FormControl
                                                componentClass='select'
                                                name='countryOfCitizenship'
                                                id='countryOfCitizenship'
                                                value={this.state.data.countryOfCitizenship}
                                                style={{ paddingRight: '30px' }}
                                                onChange={this.handleDataChange}
                                            >
                                                <option value=''>- Please Select -</option>
                                                {this.state.countryList.map(item =>
                                                    <option key={'ctry-' + item.id} value={item.id}>
                                                        {item.description}
                                                    </option>
                                                )}
                                            </FormControl>
                                            <i className='fa fa-flag' style={{
                                                position: 'absolute',
                                                right: '10px',
                                                top: '50%',
                                                transform: 'translateY(-50%)',
                                                color: '#7f8c8d',
                                                pointerEvents: 'none'
                                            }}></i>
                                        </div>
                                    </Col>
                                </FormGroup>
                            </Panel.Body>
                        </Panel>

                        <Panel>
                            <Panel.Heading>Address Information</Panel.Heading>
                            <Panel.Body>
                                {this.state.dirty && this.state.data && invalidAddress && (
                                    <div className='alert alert-warning' style={{ marginBottom: '15px' }}>
                                        <strong>Address Incomplete:</strong> Please fill in all address fields or leave them all empty.
                                    </div>
                                )}

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.addressLine1 ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='addressLine1'>
                                        Street Address Line 1:
                                     </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='addressLine1'
                                            id='addressLine1'
                                            type='text'
                                            value={this.state.data.addressLine1 || ''}
                                            onChange={this.handleDataChange}
                                        />
                                        {this.state.dirty && !this.state.validationSave.addressLine1 && (
                                            <HelpBlock>Street address is required</HelpBlock>
                                        )}
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.addressLine2 ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='addressLine2'>
                                        Street Address Line 2:
                                        <span className='text-muted' style={{ fontSize: '12px', marginLeft: '5px' }}>
                                            <span className='badge' style={{ backgroundColor: '#6c757d' }}>optional</span>
                                        </span>
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='addressLine2'
                                            id='addressLine2'
                                            type='text'
                                            value={this.state.data.addressLine2 || ''}
                                            onChange={this.handleDataChange}
                                        />
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.city ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='city'>
                                        City/Town/Locality:
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='city'
                                            id='city'
                                            type='text'
                                            value={this.state.data.city || ''}
                                            onChange={this.handleDataChange}
                                        />
                                        {this.state.dirty && !this.state.validationSave.city && (
                                            <HelpBlock>City is required</HelpBlock>
                                        )}
                                    </Col>
                                </FormGroup>

                                <FormGroup style={{ marginBottom: '20px' }} validationState={this.state.dirty && !this.state.validationSave.state ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='state' style={{ fontWeight: 600, color: '#2c3e50' }}>
                                        State/Province/Region:
                                        {this.state.data.country === Country.UnitedStates && (
                                            <span className='text-danger' style={{ marginLeft: '3px' }}>*</span>
                                        )}
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        {this.state.data.country == Country.UnitedStates ?
                                            <FormControl
                                                componentClass='select'
                                                name='state'
                                                id='state'
                                                value={this.state.data.state || ''}
                                                onChange={this.handleDataChange}
                                                disabled={this.state.data.country && this.state.data.country !== Country.UnitedStates}
                                            >
                                                <option value=''>- Please Select -</option>
                                                {this.state.stateList.map(item =>
                                                    <option key={'state-' + item.id} value={item.id}>
                                                        {item.description}
                                                    </option>
                                                )}
                                            </FormControl>
                                            :
                                            <FormControl
                                                className='form-control'
                                                name='province'
                                                id='province'
                                                type='text'
                                                value={this.state.data.province || ''}
                                                onChange={this.handleDataChange}
                                            />
                                        }

                                        {this.state.dirty && !this.state.validationSave.state &&
                                            <HelpBlock>
                                                {this.state.data.country === Country.UnitedStates ?
                                                    'State/Province/Region is required for US addresses'
                                                    :
                                                    'State/Province/Region is required'}
                                            </HelpBlock>
                                        }

                                        {this.state.data.country !== Country.UnitedStates &&
                                            <HelpBlock style={{ color: '#7f8c8d', fontSize: '12px' }}>
                                                <i className='fa fa-info-circle' style={{ marginRight: '4px' }}></i>
                                                State/Province/Region is optional for non-US addresses
                                            </HelpBlock>
                                        }
                                    </Col>
                                </FormGroup>

                                <FormGroup validationState={this.state.dirty && !this.state.validationSave.postalCode ? 'error' : null}>
                                    <ControlLabel className='col-xs-12 col-sm-3' htmlFor='postalCode'>
                                        Postal Code:
                                    </ControlLabel>
                                    <Col xs={12} sm={6}>
                                        <FormControl
                                            className='form-control'
                                            name='postalCode'
                                            id='postalCode'
                                            type='text'
                                            value={this.state.data.postalCode || ''}
                                            onChange={this.handleDataChange}
                                        />
                                        {this.state.dirty && !this.state.validationSave.postalCode && (
                                            <HelpBlock>
                                                {this.state.data.country === Country.UnitedStates ?
                                                    'Please enter a valid US postal code (12345 or 12345-6789)'
                                                    :
                                                    'Postal code is required'}
                                            </HelpBlock>
                                        )}
                                    </Col>
                                </FormGroup>
                            </Panel.Body>
                        </Panel>

                        <div className='form-section' style={{ marginTop: '30px', paddingTop: '20px', borderTop: '1px solid #ecf0f1' }}>
                            <FormGroup>
                                <Col xs={12} sm={4} smOffset={4}>
                                    <Button
                                        className='btn btn-primary col-xs-12'
                                        onClick={this.handleCreateDonorRequest}
                                        style={{
                                            padding: '10px 20px',
                                            fontSize: '16px',
                                            fontWeight: 600
                                        }}
                                    >
                                        <i className='fa fa-save' style={{ marginRight: '8px' }}></i>
                                        {this.state.data.id ? 'Save Changes' : 'Save & Send Invitation'}
                                    </Button>
                                </Col>
                            </FormGroup>
                        </div>
                    </Col>
                </Row>
            </>
        )
    }
}

const mapStateToProps = (state: IApplicationState): IStateProps => {
    return {
        app: state.app
    };
}

const mapDispatchToProps = (dispatch: Dispatch<any>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            return dispatch(AppActionCreators.hideLoading());
        },
        getDonorShieldDirectRecord: (donorShieldId, centerId) => {
            return dispatch(WatrActionCreators.getDonorShieldDirectRecord(donorShieldId, centerId));
        },
        getDonorRecord: (donorId, centerId) => {
            return dispatch(WatrActionCreators.getDonorRecord(donorId, centerId));
        },
        getWatrRequestRecord: (watrId, centerId) => {
            return dispatch(WatrActionCreators.getWatrRequestRecord(watrId, centerId));
        },
        createDonorRequest: (donorId, donorShieldId, firstName, middleInitial, lastName, email, mobile, birthDate, donationDate, addressLine1, addressLine2, city, state, postalCode, country, countryOfCitizenship, centerId, isSuperUser) => {
            return dispatch(WatrActionCreators.createDonorRequest(donorId, donorShieldId, firstName, middleInitial, lastName, email, mobile, birthDate, donationDate, addressLine1, addressLine2, city, state, postalCode, country, countryOfCitizenship, centerId, isSuperUser));
        },
        updateDonorRequest: (request) => {
            return dispatch(WatrActionCreators.updateDonorRequest(request));
        },
        getDuplicateCounts: (watrId, email, mobile, donationOrganType) => {
            return dispatch(WatrActionCreators.getDuplicateCounts(watrId, email, mobile, donationOrganType));
        },
        getLookupData: () => {
            return dispatch(WatrActionCreators.getLookupData());
        }
    }
}


export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(AddRequestForm);